// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PostCover_wrapper__pYUE4","image":"PostCover_image__8RsXg"};